// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background-color: black;
  max-height: 48px;
  display: flex;
  justify-content: space-between;
  color: white;
}
.navbar-brand {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 20%;
  font-size: 16px;
  font-weight: 400;
}
.navbar-icon {
  padding: 16px;
  display: flex;
  align-items: center;
}
.navbar-brand-separator {
  border: 1px solid #53565a;
  height: 100%;
}
.navbar-brand-text {
  white-space: nowrap;
}
.navbar-brand-workspace {
  font-weight: 300;
}
`, "",{"version":3,"sources":["webpack://./src/css/navbar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".navbar {\n  background-color: black;\n  max-height: 48px;\n  display: flex;\n  justify-content: space-between;\n  color: white;\n}\n.navbar-brand {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 20%;\n  font-size: 16px;\n  font-weight: 400;\n}\n.navbar-icon {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n}\n.navbar-brand-separator {\n  border: 1px solid #53565a;\n  height: 100%;\n}\n.navbar-brand-text {\n  white-space: nowrap;\n}\n.navbar-brand-workspace {\n  font-weight: 300;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
